import { useTranslation } from 'react-i18next'
import { useActiveMenu } from '../app/nav/useActiveMenu'
import PageHeader from '../components/ui/PageHeader'
import EmptyState from '../components/ui/EmptyState'

/**
 * Modül sayfaları henüz geliştirilmedi; her rota bu placeholder'ı gösterir.
 * Başlık aktif menü öğesinden gelir (anayasa: sayfa başlığı = menü adı).
 *
 * Tasarımı verilmeyen bir sayfa örneği (013 US3): yalnız paylaşılan tasarım dili bileşenleriyle
 * (PageHeader + EmptyState) kurulur → mevcut ekranlarla görsel bütünlük içinde.
 */
export default function PlaceholderPage() {
  const { t } = useTranslation()
  const active = useActiveMenu()
  const title = active ? t((active.item ?? active.module).labelKey) : ''
  return (
    <div className="page">
      <PageHeader title={title} />
      <EmptyState icon="pi pi-cog" title={t('shell.placeholder')} />
    </div>
  )
}
